"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialAsyncState = void 0;
const types_1 = require("../types");
exports.initialAsyncState = {
    status: types_1.ActionStatus.INITIAL,
    data: null,
    errors: null,
};
//# sourceMappingURL=WithManipulationState.js.map